import type { VoiceResponse } from '../protocol'

/** Почему расшифровка пустая: по замерам сервера отличаем «микрофон молчал»
 *  от «слов не разобрали», чтобы человек понял, что чинить. */
export function emptyVoiceReason(res: VoiceResponse, recordedSec: number): string {
  const total = res.durationSec || recordedSec
  const active = res.activeSec
  if (typeof active === 'number') {
    if (active < 0.5) {
      return 'микрофон не записал звук — проверьте, какой микрофон выбран, и не отключён ли он'
    }
    if (total >= 10 && active < total * 0.1) {
      return `звук был только ${active.toFixed(1)} с из ${Math.round(total)} с — микрофон замолчал ` +
        'во время записи; проверьте выбранный микрофон'
    }
  }
  return 'расшифровка пустая — попробуйте ещё раз'
}
